

import React, { useState, useEffect } from 'react';
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/20/solid';

const AddCalendarDialogSimple = ({ isOpen, onClose, onSubmit }) => {
  const [calendarName, setCalendarName] = useState('');

  useEffect(() => {
    if (!isOpen) {
      setCalendarName('');
    }
  }, [isOpen]);

  const handleSubmit = () => {
    const name = calendarName.trim();
    if (!name) return;
    onSubmit({ name });
    setCalendarName('');
  };

  return (
    <Dialog open={isOpen} onClose={onClose} className="relative z-10">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />
      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <DialogPanel
            transition
            className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-md sm:p-4"
          >
            <div className="relative p-0">
              <button
                type="button"
                onClick={onClose}
                className="absolute top-1 right-1 p-1 rounded-full bg-black hover:bg-gray-800 transition-colors duration-200 text-white hover:text-gray-200 z-10"
                aria-label="Close"
              >
                <XMarkIcon className="w-4 h-4" />
              </button>
            </div>
            {/* Header with border-bottom */}
            <div className="border-b border-gray-200 py-4 mb-8">
              <DialogTitle as="h3" className="text-lg font-medium leading-6 text-gray-900">
                Add New Category
              </DialogTitle>
            </div>
            {/* Main content */}
            <div className="mt-8 px-4">
              <div className="flex items-center space-x-4">
                <label
                  htmlFor="calendarName"
                  className="block text-sm font-medium text-gray-900 w-1/3"
                >
                  Category Name
                </label>
                <div className="flex-grow">
                  <input
                    id="calendarName"
                    name="calendarName"
                    type="text"
                    placeholder="Enter Category name"
                    value={calendarName}
                    onChange={(e) => setCalendarName(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' && calendarName.trim()) {
                        handleSubmit();
                      }
                    }}
                    className="block w-full rounded-md border-0 py-2 px-3 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-black text-sm"
                  />
                </div>
              </div>
            </div>
            {/* Button Section with top border, flush to bottom, matching AddCalendarDialog.js */}
            <div className="border-t border-gray-200 pt-5 pb-0 px-4 mt-8">
              <div className="flex justify-between">
                <button
                  type="button"
                  onClick={onClose}
                  className="rounded-md bg-gray-200 text-gray-700 py-2 px-4 hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-black focus:ring-offset-2"
                >
                  Close
                </button>
                <button
                  type="button"
                  onClick={handleSubmit}
                  disabled={!calendarName.trim()}
                  className={`rounded-md ${!calendarName.trim() ? "bg-gray-400 cursor-not-allowed" : "bg-black hover:bg-gray-800"} text-white py-2 px-4 focus:outline-none focus:ring-2 focus:ring-black focus:ring-offset-2`}
                >
                  Create
                </button>
              </div>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
};

export default AddCalendarDialogSimple;
